import React, { useEffect, useState } from 'react';
import { bankGuaranteesEnhancedAPI } from '../../../services/bgFinanceService';
import { formatCurrency } from './bgShared';
import { formatDateIN } from '../../../utils/dateFormat';
import TableEmptyRow from '../../../components/TableEmptyRow';

const RenewalHistoryPopup = ({ bgId, bgNo, onClose, anchorStyle }) => {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!bgId) return;
    setLoading(true);
    bankGuaranteesEnhancedAPI.getRenewals(bgId)
      .then((res) => setRows(res?.data?.data || []))
      .catch(() => setRows([]))
      .finally(() => setLoading(false));
  }, [bgId]);

  return (
    <div
      style={{
        position: 'absolute',
        zIndex: 20,
        background: '#fff',
        border: '1px solid #e5e7eb',
        borderRadius: 8,
        boxShadow: '0 8px 24px rgba(0,0,0,0.12)',
        minWidth: 320,
        maxWidth: 420,
        padding: 12,
        ...anchorStyle,
      }}
      onClick={(e) => e.stopPropagation()}
    >
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 8 }}>
        <strong style={{ fontSize: 13 }}>Renewal History — {bgNo}</strong>
        <button type="button" className="btn-secondary btn-sm" onClick={onClose}>✕</button>
      </div>
      {loading ? (
        <p style={{ fontSize: 12, color: '#6b7280' }}>Loading...</p>
      ) : rows.length === 0 ? (
        <p style={{ fontSize: 12, color: '#6b7280' }}>No renewals recorded yet.</p>
      ) : (
        rows.map((r) => (
          <div key={r.id} style={{ borderTop: '1px solid #f3f4f6', paddingTop: 8, marginTop: 8, fontSize: 12 }}>
            <p style={{ fontWeight: 600, margin: '0 0 4px' }}>Renewal #{r.renewal_no}</p>
            <p style={{ margin: '2px 0' }}>Renewal Date: {formatDateIN(r.renewal_date)}</p>
            <p style={{ margin: '2px 0' }}>Previous Expiry: {formatDateIN(r.previous_expiry_date)} → New: {formatDateIN(r.new_expiry_date)}</p>
            <p style={{ margin: '2px 0' }}>Amount: {formatCurrency(r.previous_amount)} → {formatCurrency(r.new_amount)}</p>
            <p style={{ margin: '2px 0' }}>Renewed By: {r.renewed_by?.name || '—'}</p>
            {r.remarks && <p style={{ margin: '2px 0', color: '#6b7280' }}>{r.remarks}</p>}
          </div>
        ))
      )}
    </div>
  );
};

export const RenewalHistorySection = ({ rows = [] }) => (
  <div style={{ marginTop: 16 }}>
    <h4 style={{ fontSize: 14, fontWeight: 600, marginBottom: 8 }}>Renewal History</h4>
    <div className="table-container">
      <table className="data-table">
        <thead>
          <tr>
            <th>Renewal No.</th>
            <th>Reference</th>
            <th>Renewal Date</th>
            <th>Previous Expiry</th>
            <th>New Expiry</th>
            <th>Previous Amount</th>
            <th>New Amount</th>
            <th>Renewed By</th>
            <th>Remarks</th>
          </tr>
        </thead>
        <tbody>
          {rows.length === 0 ? (
            <TableEmptyRow colSpan={9} message="No renewal history." />
          ) : rows.map((r) => (
            <tr key={r.id}>
              <td>{r.renewal_no}</td>
              <td>{r.renewal_reference_no || '—'}</td>
              <td>{formatDateIN(r.renewal_date)}</td>
              <td>{formatDateIN(r.previous_expiry_date)}</td>
              <td>{formatDateIN(r.new_expiry_date)}</td>
              <td className="amount-cell">{formatCurrency(r.previous_amount)}</td>
              <td className="amount-cell">{formatCurrency(r.new_amount)}</td>
              <td>{r.renewed_by?.name || '—'}</td>
              <td>{r.remarks || '—'}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  </div>
);

export default RenewalHistoryPopup;
